$ = require('jquery')

window.jQuery ?= $

window.App =
	doComponents: (method, payload) ->
		for component in @components
			component[method]?(
				$target: payload.$target
			)

		return this

	run: (options) ->
		# set options
		@options = options

		# touch
		@supportsTouch = 'ontouchstart' of window or navigator.msMaxTouchPoints
		if @supportsTouch
			$('html').addClass('touch')
		else
			$('html').addClass('no-touch')

		# components
		@components = [
			require('./components/eventActions')
			require('./components/scrollbar')
			require('./components/forms')
			require('./components/carousel')
			require('./components/stars')
			require('./components/multislider')
			require('./components/fancybox')
			require('./components/suggest')
			require('./components/matchHeight')
			require('./components/fixed')
			require('./components/filter')
			require('./components/fixedMenu')
			require('./components/menu')
			require('./components/submenu')
		]

		# init na dokument
		@doComponents('init',
			$target: $(document)
		)

		return




// WEBPACK FOOTER //
// ./src/js/app.coffee